module.exports = __webpack_public_path__ + "img/4.eecf9eb2.jpg";